import { render, staticRenderFns } from "./page-with-chatbox.vue?vue&type=template&id=c9b2555a&lang=pug&"
import script from "./page-with-chatbox.vue?vue&type=script&lang=js&"
export * from "./page-with-chatbox.vue?vue&type=script&lang=js&"
import style0 from "./page-with-chatbox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports